import template from './user-vouches.html';
import userVouchesController from './user-vouches.controller';
import './user-vouches.styl';

let userVouchesComponent = {
  restrict: 'E',
  bindings: {
    vouches: '<'
  },
  template,
  controller: userVouchesController,
  controllerAs: 'vm'
};

export default userVouchesComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-vouches/user-vouches.component.js
 **/